(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["full-width-compatibility-12pin"] && !Shopify.designMode) return;
  try {
    

/*document.getElementById('shopify-section-page-title').style.height = "70px";*/



console.log("Test");

yearSelect = document.getElementById("year");
countrySelect = document.getElementById("country");
makeSelect = document.getElementById("make");
modelSelect = document.getElementById("model");
engineSelect = document.getElementById("engine");

yearSelect.selectedIndex = 0;
countrySelect.selectedIndex = 0;


for (let i = 2023; i >= 1996; i--) 
{
    yearSelect.add(new Option(i, i));
}

mmyeFlex = document.getElementById("mmye-flex");

let countryCode;

let option = document.createElement("option");
option.value = "";

countrySelect.addEventListener("change", function(e)   {

    mmyeFlex.style.display = "none";
    hideContentRectangles();

    document.getElementById("year").selectedIndex = "0"; 

    document.querySelectorAll('#make option').forEach(option => option.remove())
    makeSelect.add(new Option("Make", ""));

    document.querySelectorAll('#model option').forEach(option => option.remove())
    modelSelect.add(new Option("Model", ""));

    document.querySelectorAll('#engine option').forEach(option => option.remove())
    engineSelect.add(new Option("Engine", ""));   

    hideLabel("year");
    hideLabel("model");
    hideLabel("make");
    hideLabel("engine");     

    switch (countrySelect.value) {
        case 'US':
        case 'CA':
		case 'PR':
            mmyeFlex.style.display = "flex";
            document.getElementById("countryIncompatibleRectangle").style.display = "none";
            break;
        default:
            mmyeFlex.style.display = "none";
            document.getElementById("restrictionDisplayContent").classList.toggle("active", false);
            document.getElementById("unknownEnhancedContent").classList.toggle("active", false);
            document.getElementById("obdUnsupportedContent").classList.toggle("active", false);
            document.getElementById("messageDisplayContent").classList.toggle("active", false);

            document.getElementById("countryIncompatibleRectangle").style.display = "flex";

            hideLabel("year");
            hideLabel("model");
            hideLabel("make");
            hideLabel("engine");
    }
    
    switch (countrySelect.value) {
        case 'US':
        case 'CA':
            break;
        case 'MX':
        case 'HK':
        case 'NZ':
            document.getElementById("countryIncompatibleText").innerHTML = "<strong>Petrol &amp; Diesel:</strong> All <strong>2006</strong> or newer car &amp; light truck (i.e. SUVs, pickups, minivans, etc.) makes &amp; models work with BlueDriver.<p><strong>Enhanced codes</strong> (ABS, SRS, etc) are available for most compatible vehicles from GM, Ford, Chrysler, Toyota, Mazda, Mitsubishi, Mercedes-Benz, Hyundai, and Nissan.</p><p><strong>Repair Reports</strong> are available for vehicles with North American VINs only.</p>";
            break;
        case 'AL':
        case 'AD':
        case 'AT':
        case 'BY':
        case 'BE':
        case 'BA':
        case 'BG':
        case 'HR':
        case 'CY':
        case 'CZ':
        case 'DK':
        case 'EE':
        case 'FO':
        case 'FI':
        case 'FR':
        case 'DE':
        case 'GI':
        case 'GR':
        case 'HU':
        case 'IS':
        case 'IE':
        case 'IT':
        case 'LV':
        case 'LI':
        case 'LT':
        case 'LU':
        case 'MK':
        case 'MT':
        case 'MD':
        case 'MC':
        case 'NL':
        case 'NO':
        case 'PL':
        case 'PT':
        case 'RO':
        case 'RU':
        case 'SM':
        case 'RS':
        case 'SK':
        case 'SI':
        case 'ES':
        case 'SE':
        case 'CH':
        case 'UA':
        case 'GB':
        case 'VA':
        case 'YU':
        case 'IM':
        case 'RS':
        case 'ME':
            document.getElementById("countryIncompatibleText").innerHTML = "<strong>Petrol:</strong> All <strong>2001</strong> or newer car &amp; light truck (i.e. SUVs, pickups, minivans, etc.) makes &amp; models work with BlueDriver.<p><strong>Diesel:</strong> All <strong>2004</strong> or newer car &amp; light truck (i.e. SUVs, pickups, minivans, etc.) makes &amp; models work with BlueDriver.</p><p><strong>Enhanced codes</strong> (ABS, SRS, etc) are available for most compatible vehicles from GM, Ford, Chrysler, Toyota, Mazda, Mitsubishi, Mercedes-Benz, Hyundai, and Nissan.</p><p><strong>Repair Reports</strong> are not currently available in Europe.</p>";
            break;
        case 'AR':
        case 'KR':
            document.getElementById("countryIncompatibleText").innerHTML = "<strong>Petrol &amp; Diesel:</strong> All <strong>2009</strong> or newer car &amp; light truck (i.e. SUVs, pickups, minivans, etc.) makes &amp; models work with BlueDriver.<p><strong>Enhanced codes</strong> (ABS, SRS, etc) are available for most compatible vehicles from GM, Ford, Chrysler, Toyota, Mazda, Mitsubishi, Mercedes-Benz, Hyundai, and Nissan.</p><p><strong>Repair Reports</strong> are available for vehicles with North American VINs only.</p>";
            break;
        case 'BR':
            document.getElementById("countryIncompatibleText").innerHTML = "<strong>Petrol:</strong> All <strong>2010</strong> or newer car &amp; light truck (i.e. SUVs, pickups, minivans, etc.) makes &amp; models work with BlueDriver.<p><strong>Diesel:</strong> Sorry, there is no published standard for OBD2-compliance for diesel vehicles in your country (which BlueDriver uses for data), therefore the support may vary from vehicle to vehicle. If the vehicle has a sticker in the engine bay or states in the owners manual that it is OBD2-compliant (or EOBD-compliant), it will work with BlueDriver.</p><p><strong>Enhanced codes</strong> (ABS, SRS, etc) are available for most compatible vehicles from GM, Ford, Chrysler, Toyota, Mazda, Mitsubishi, Mercedes-Benz, Hyundai, and Nissan.</p><p><strong>Repair Reports</strong> are available for vehicles with North American VINs only.</p>";
            break;
        case 'IL':
            document.getElementById("countryIncompatibleText").innerHTML = "<strong>Petrol &amp; Diesel:</strong> All <strong>2003</strong> or newer car &amp; light truck (i.e. SUVs, pickups, minivans, etc.) makes &amp; models work with BlueDriver.<p><strong>Enhanced codes</strong> (ABS, SRS, etc) are available for most compatible vehicles from GM, Ford, Chrysler, Toyota, Mazda, Mitsubishi, Mercedes-Benz, Hyundai, and Nissan.</p><p><strong>Repair Reports</strong> are available for vehicles with North American VINs only.</p>";
            break;
        case 'CN':
            document.getElementById("countryIncompatibleText").innerHTML = "<strong>Petrol:</strong> All <strong>2009</strong> or newer car &amp; light truck (i.e. SUVs, pickups, minivans, etc.) makes &amp; models work with BlueDriver.<p><strong>Diesel:</strong> All <strong>2011</strong> or newer car &amp; light truck (i.e. SUVs, pickups, minivans, etc.) makes &amp; models work with BlueDriver.</p><p><strong>Enhanced codes</strong> (ABS, SRS, etc) are available for most compatible vehicles from GM, Ford, Chrysler, Toyota, Mazda, Mitsubishi, Mercedes-Benz, Hyundai, and Nissan.</p><p><strong>Repair Reports</strong> are available for vehicles with North American VINs only.</p>";
            break;
        case 'IN':
        case 'TH':
            document.getElementById("countryIncompatibleText").innerHTML = "<strong>Petrol &amp; Diesel:</strong> All <strong>2013</strong> or newer car &amp; light truck (i.e. SUVs, pickups, minivans, etc.) makes &amp; models work with BlueDriver.<p><strong>Enhanced codes</strong> (ABS, SRS, etc) are available for most compatible vehicles from GM, Ford, Chrysler, Toyota, Mazda, Mitsubishi, Mercedes-Benz, Hyundai, and Nissan.</p><p><strong>Repair Reports</strong> are available for vehicles with North American VINs only.</p>";
            break;
        case 'JP':
            document.getElementById("countryIncompatibleText").innerHTML = "<strong>Petrol &amp; Diesel:</strong> All <strong>2010</strong> or newer car &amp; light truck (i.e. SUVs, pickups, minivans, etc.) makes &amp; models work with BlueDriver.<p><strong>Enhanced codes</strong> (ABS, SRS, etc) are available for most compatible vehicles from GM, Ford, Chrysler, Toyota, Mazda, Mitsubishi, Mercedes-Benz, Hyundai, and Nissan.</p><p><strong>Repair Reports</strong> are available for vehicles with North American VINs only.</p>";
            break;
        case 'TW':
            document.getElementById("countryIncompatibleText").innerHTML = "<strong>Petrol &amp; Diesel:</strong> All <strong>2008</strong> or newer car &amp; light truck (i.e. SUVs, pickups, minivans, etc.) makes &amp; models work with BlueDriver.<p><strong>Enhanced codes</strong> (ABS, SRS, etc) are available for most compatible vehicles from GM, Ford, Chrysler, Toyota, Mazda, Mitsubishi, Mercedes-Benz, Hyundai, and Nissan.</p><p><strong>Repair Reports</strong> are available for vehicles with North American VINs only.</p>";
            break;
        case 'AU':
            document.getElementById("countryIncompatibleText").innerHTML = "<strong>Petrol:</strong> All <strong>2006</strong> or newer car &amp; light truck (i.e. SUVs, pickups, minivans, etc.) makes &amp; models work with BlueDriver.<p><strong>Diesel:</strong> All <strong>2007</strong> or newer car &amp; light truck (i.e. SUVs, pickups, minivans, etc.) makes &amp; models work with BlueDriver.</p><p><strong>Enhanced codes</strong> (ABS, SRS, etc) are available for most compatible vehicles from GM, Ford, Chrysler, Toyota, Mazda, Mitsubishi, Mercedes-Benz, Hyundai, and Nissan.</p><p><strong>Repair Reports</strong> are available for vehicles with North American VINs only.</p>";
            break;
        case '':
            break;
        default:
            document.getElementById("countryIncompatibleText").innerHTML = "BlueDriver is compatible with all vehicles that support OBDII diagnostics. However, OBDII compliance varies depending on geographical region and year. For example, North America began requiring OBDII compliance in 1996, and Europe in 2001 (2004 for diesel).<br><br>"
            + "<strong>Unfortunately, " + countrySelect.options[countrySelect.selectedIndex].text.toUpperCase() + " does not require the use of OBDII diagnostics in locally sold vehicles. As a result, we cannot guarantee that any vehicle sold in this region will be compatible with BlueDriver.</strong><br><br>"
            + "<strong>If your vehicle has a sticker or plate in the engine bay that states 'OBDII Certified' or 'EOBD Compatible' your vehicle will support:</strong><br><br>";
    }
});

yearSelect.addEventListener("change", function(e)   { 

    hideContentRectangles();

    document.querySelectorAll('#make option').forEach(option => option.remove())
    makeSelect.add(new Option("Make", ""));

    document.querySelectorAll('#model option').forEach(option => option.remove())
    modelSelect.add(new Option("Model", ""));

    document.querySelectorAll('#engine option').forEach(option => option.remove())
    engineSelect.add(new Option("Engine", ""));

    hideLabel("engine");
    hideLabel("model");
    hideLabel("make");

    let makesList = [];

    for (let x in data)  
    {
        for (let y in data[x])
        {
            for (let z in data[x][y])
            {
                if (z === yearSelect.value)
                {
                    if (!makesList.includes(x))
                    {
                        makeSelect.add(new Option(x, x));                                        
                        makesList.push(x);
                    }
                }
            }
        }         
    }
    

    if (yearSelect.value == "")
    {
        hideLabel("year");
    }

    else
    {
        document.getElementById("year").style.fontSize = "14px";
        document.getElementById("year").style.paddingTop = "14px";
        document.getElementById("year").style.paddingBottom = "2px";
        document.getElementById("year label").style.display = "block";
    }
});

makeSelect.addEventListener("change", function(e) { 

    hideContentRectangles();

    document.querySelectorAll('#model option').forEach(option => option.remove())
    modelSelect.add(new Option("Model", ""));

    document.querySelectorAll('#engine option').forEach(option => option.remove())
    engineSelect.add(new Option("Engine", ""));

    hideLabel("engine");
    hideLabel("model");

    for (let y in data[makeSelect.value])
    {
        for (let z in data[makeSelect.value][y]) 
        {
            if ((data[makeSelect.value][y][yearSelect.value] == data[makeSelect.value][y][z]))
            {
                modelSelect.add(new Option(y, y));
            }
        }
    }

    if (makeSelect.value == "")
    {
        hideLabel("year");
    }

    else
    {
        document.getElementById("make").style.fontSize = "14px";
        document.getElementById("make").style.paddingTop = "14px";
        document.getElementById("make").style.paddingBottom = "2px";
        document.getElementById("make label").style.display = "block";        
    }
});

modelSelect.addEventListener("change", function(e) {

    hideContentRectangles();

    document.querySelectorAll('#engine option').forEach(option => option.remove())
    engineSelect.add(new Option("Engine", ""));

    hideLabel("engine");

    if (data[makeSelect.value][modelSelect.value] !== undefined)
    {
        for (let z in data[makeSelect.value][modelSelect.value][yearSelect.value]) 
        {
            engineSelect.add(new Option(z, z));
        }
    }
        
    if (modelSelect.value == "")
    {
        hideLabel("year");
    }

    else
    {
        document.getElementById("model").style.fontSize = "14px";
        document.getElementById("model").style.paddingTop = "14px";
        document.getElementById("model").style.paddingBottom = "2px";
        document.getElementById("model label").style.display = "block";        
    }
});

engineSelect.addEventListener("input", function(e) {

    let engineData = data[makeSelect.value][modelSelect.value][yearSelect.value][engineSelect.value];
    let serviceData = makeSelect.value;

    hideContentRectangles();

    document.getElementById("additional-systems-title").style.display = "none";

    document.getElementById("serviceFeatures").style.display = "none";

    document.getElementById("liveDataContent").innerHTML = "";
    document.getElementById("liveDataPids").innerHTML = "";
    document.getElementById("restrictionDisplayContent").innerHTML = "";
    

    if (engineSelect.options[engineSelect.selectedIndex].text == "Engine") 
    {
        hideContentRectangles();
    }

    else 
    {
        document.getElementById("mmye-display").innerHTML = 
         "<span class='divider'>"+ countrySelect.options[countrySelect.selectedIndex].text+ " </span> "
        +  "<span class='divider'>"+yearSelect.options[yearSelect.selectedIndex].text + " </span> "
        +  "<span class='divider'>"+makeSelect.options[makeSelect.selectedIndex].text + " </span> "
        +  "<span class='divider'>"+modelSelect.options[modelSelect.selectedIndex].text + " </span> "
        +  "<span class='divider'>"+engineSelect.options[engineSelect.selectedIndex].text +" </span> ";
       

        document.getElementById("selector-flex").style.display = "none";

        document.getElementById("mmye-display").style.display = "flex";
        document.getElementById("mmye-edit-button").style.display = "flex";

        if (engineData["Message"] !== null)
        {
            document.getElementById("messageDisplayContent").innerHTML = "<strong>COMPATIBILITY NOTE: </strong>" + engineData["Message"];
            document.getElementById("messageDisplayContent").classList.toggle("active", true);
        }
            
        else 
        {
            document.getElementById("messageDisplayContent").classList.toggle("active", false);  
            document.getElementById("messageDisplayContent").innerHTML = "";              
        }

        if (engineData["OBD"] === false)
        {
            document.getElementById("obdUnsupportedContent").classList.toggle("active",true);           
        }

        else 
        {
            document.getElementById("obdUnsupportedContent").classList.toggle("active",false);

            fetchServiceFeatures(serviceData);

            if ((engineData["PID"] === null) || (engineData["PID"] === "0"))
            {
                document.getElementById("liveDataContent").innerHTML = 
                "Your vehicle supports live data, but we do not currently have a list of what datapoints are available. " +
                "Your vehicle will provide this list to the scanner on connection. If you have any questions, please contact support any time.";
            }

            else 
            {
                fetchLiveData(engineData["PID"]);
            }

            if (engineData["Restrictions"] !== null)
            {
                if (engineData["Enhanced"] === true)
                {
                    let restrictionList = "<strong>";

                    document.getElementById('restrictionDisplayContent').style.border = "1px solid #b21515";
                    document.getElementById('restrictionDisplayContent').style.color = "#b21515";                    

                    for (let x in engineData["Restrictions"])
                    {

                        if ((engineData["Restrictions"][x] === ("Canada" || "CA")) && (countrySelect.value === "CA"))
                        {
                            document.getElementById('restrictionDisplayContent').style.border = "1px solid #202326";
                            document.getElementById('restrictionDisplayContent').style.color = "black";                            
                        }

                        if ((engineData["Restrictions"][x] === ("United States" || "US")) && (countrySelect.value === "US"))
                        {
                            document.getElementById('restrictionDisplayContent').style.border = "1px solid #202326";
                            document.getElementById('restrictionDisplayContent').style.color = "black";                            
                        }

                        if (x == 0)
                        {
                            restrictionList += engineData["Restrictions"][x];
                        }
                        
                        else
                        {
                            restrictionList += " & " + engineData["Restrictions"][x];
                        }

                    }              
                    
                    restrictionList += "</strong>";
                        
                    document.getElementById("restrictionDisplayContent").classList.toggle("active", true);

                    document.getElementById("restrictionDisplayContent").innerHTML =
                    "<strong>REGION NOTE: </strong>Enhanced diagnostic features are available in " + restrictionList +
                    ". Outside of these regions, all features will be available except enhanced systems (ABS, Airbags, etc.)"
                }
            }

            if ((engineData["Enhanced"] === false) || (engineData === undefined))
            {
                document.getElementById("unknownEnhancedContent").classList.toggle("active", false);
                document.getElementById("basicSupportedFeatures").style.display = "flex";
                document.getElementById("liveData").style.display = "flex";
                document.getElementById("enhancedDiagnostics").style.display = "none";
                document.getElementById("enhancedAdditionalFeatures").style.display = "none";
            }

            else
            {
                if (engineData["Systems"] === null)
                {
                    document.getElementById("unknownEnhancedContent").classList.toggle("active", true);
                    document.getElementById("enhancedDiagnostics").style.display = "none";
                    document.getElementById("enhancedAdditionalFeatures").style.display = "none";
                    document.getElementById("basicSupportedFeatures").style.display = "flex";
                }

                else if (engineData["Systems"] === undefined)
                {                    
                    document.getElementById("unknownEnhancedContent").classList.toggle("active", false);
                    document.getElementById("enhancedDiagnostics").style.display = "none";
                    document.getElementById("enhancedAdditionalFeatures").style.display = "flex";
                    document.getElementById("basicSupportedFeatures").style.display = "none";
                }

                else
                {
                    systemAvailabilityUpdate(engineData);
                    
                    document.getElementById("enhancedDiagnostics").style.display = "flex";
                    document.getElementById("enhancedAdditionalFeatures").style.display = "flex";
                    document.getElementById("basicSupportedFeatures").style.display = "none";
                }

                document.getElementById("liveData").style.display = "flex";
            }
        }
    }

    if (engineSelect.value == "")
    {
        hideLabel("year");     
    }

    else
    {
        document.getElementById("engine").style.fontSize = "14px";
        document.getElementById("engine").style.paddingTop = "14px";
        document.getElementById("engine").style.paddingBottom = "2px";
        document.getElementById("engine label").style.display = "block";        
    }
});

document.getElementById("countryRequirementText").addEventListener("click", function(e) { 

    document.getElementById("country-requirement-display").classList.toggle("shrunk", true);
});

document.getElementById("country-requirement-display-close").addEventListener("click", function(e) { 

    document.getElementById("country-requirement-display").classList.toggle("shrunk", false);
});

window.addEventListener("load", function(e) {
});

document.getElementById("mmye-edit-button").addEventListener("click", function(e) {
    document.getElementById("selector-flex").style.display = "flex";
    document.getElementById("mmye-display").style.display = "none";
    document.getElementById("mmye-edit-button").style.display = "none";
});

function getText (system) {
    let additionalSystemText;

        switch (system) { 
            case 'Battery and Power': 
                additionalSystemText = "Power distribution and battery health monitoring systems.";
                break;
            case 'Doors and Windows':
                additionalSystemText = "Door controls and locks, power windows, power sliding/rear doors, convertible tops, etc.";
                break;
            case 'Driver Assist and Active Safety':
                additionalSystemText = "Active cruise control, lane assist, emergency braking, pedestrian detection, etc.";
                break;        
            case 'Driver Information and Control':
                additionalSystemText = "Instrument panel, displays/screens, buttons and control panels, etc.";
                break;        
            case 'Entertainment and Navigation':
                additionalSystemText = "Stereo, navigation systems, amplifiers, CD changers, etc.";
                break;        
            case 'Heat and Air Conditioning':
                additionalSystemText = "Heat, air conditioning, climate control.";
                break;        
            case 'Lights':
                additionalSystemText = "Headlights, interior lighting.";
                break;        
            case 'Premium Vehicle Options':
                additionalSystemText = "Wifi hotspots, sun shades, active noise cancellation, automatic running boards, etc.";
                break;        
            case 'Seats and Mirrors':
                additionalSystemText = "Heated and power seats, heated mirrors, mirror controls, etc.";
                break;        
            case 'Security & Keyless Entry':
                additionalSystemText = "Keyless entry, immobilizers, remote starters, etc.";
                break;        
            case 'Trailer and Auxiliary Equipment':
                additionalSystemText = "Trailer brakes, power take-offs, etc.";
                break;
            case 'Vehicle Control and Suspension':
                additionalSystemText = "Power steering, active/electronic suspension or dampeners, etc.";
                break;                        
            default: 
    };

    return additionalSystemText;
}

function systemAvailabilityUpdate(data) {

    document.getElementById("serviceFeatures").style.display = "none";
    document.getElementById("active-service-features").style.display = "none";

    document.getElementById("additional-systems-flex").innerHTML = "";

    document.getElementById("additional-systems-title").style.display = "none";

    for (let x in data["Systems"]["Primary"])
    {
        if (data["Systems"]["Primary"][x] === true)
        {
            document.getElementById(x + " box").style.display = "flex";

            if (x === "Engine")
            {
                document.getElementById(x).innerHTML = "<div class=\"primary-systems-check check-mark check-mark\"></div>";

                document.getElementById(x + " subtext").style.display = "block";    

                document.getElementById(x + " subtext").innerHTML = "Systems related to the operation of the engine - " + 
                "engine/powertrain controller, electronic fuel pump, starter, etc.";

                document.getElementById(x + " subtext alt").style.display = "none";
            }
            
            else 
            {
                document.getElementById(x).innerHTML = "<div class=\"primary-systems-check check-mark check-mark\"></div>";

                document.getElementById(x + " box").classList.toggle("unavailable", false); 

                document.getElementById(x + " title").classList.toggle("unavailable", false); 

                document.getElementById(x + " subtext").style.display = "block";

                document.getElementById(x + " subtext alt").style.display = "none";
            }
        }

        else if (data["Systems"]["Primary"][x] === false)
        {
            document.getElementById(x + " box").style.display = "flex";

            if (x === "Engine")
            {
                document.getElementById(x).innerHTML = "<div class=\"primary-systems-check check-mark check-mark\"></div>";

                document.getElementById(x + " subtext").style.display = "block";    

                document.getElementById(x + " subtext").innerHTML = "<strong>Note:</strong> This vehicle " +
                "only supports Check Engine Light codes from the engine module.";

                document.getElementById(x + " subtext alt").style.display = "none";
            }

            else 
            { 
                document.getElementById(x).innerHTML = "<div class=\"primary-systems-cross cross-mark\"></div>";

                document.getElementById(x + " box").classList.toggle("unavailable", true); 

                document.getElementById(x + " title").classList.toggle("unavailable", true); 

                document.getElementById(x + " subtext alt").innerHTML = "Not supported by this vehicle.";

                document.getElementById(x + " subtext").style.display = "none";

                document.getElementById(x + " subtext alt").style.display = "block";
            }
        }

        else if (data["Systems"]["Primary"][x] === null)
        {
            document.getElementById(x + " box").style.display = "none";

            document.getElementById(x + " title").classList.toggle("unavailable", true); 

            document.getElementById(x).innerHTML = "<div class=\"system-not-available\">N/A</div>";

            document.getElementById(x + " subtext alt").innerHTML = "Your vehicle does not have this system.";

            document.getElementById(x + " subtext").style.display = "none";

            document.getElementById(x + " subtext alt").style.display = "block";            
        }

        if (data["Systems"]["Primary"]["Hybrid and EV"] === true)
        {
            document.getElementById("Hybrid and EV box").style.display = "flex";
        }

        else 
        {       
            document.getElementById("Hybrid and EV box").style.display = "none";
        }
    }

    let systemCount = 0;

    for (let y in data["Systems"]["Secondary"])
    {
        if (data["Systems"]["Secondary"][y] == true) 
        {
            document.getElementById("additional-systems-title").style.display = "flex";

            if (systemCount == 0) 
            {
                divider = "";
            }

            else if (systemCount == 1)
            {
                divider = "<div class=\"system-divider-alt\"></div>";
            }
            
            else
            {
                divider = "<div class=\"system-divider\"></div>";
            }


            document.getElementById("additional-systems-flex").innerHTML += 

                "<div class=\"additional-systems-box\">" + divider +

                        "<div class=\"additional-systems-field\">" +
                            
                            "<div class=\"additional-systems-text\">" +

                                "<div class=\"additional-systems-check check-mark check-mark\"></div>" + y + "</div>" +

                            "<div class=\"additional-systems-tooltip\">" +
                                "<div class=\"text-tooltip-icon\"></div>" +
                                "<div class=\"text-tooltip-container\">" +
                                    "<div class=\"text-tooltip\">" +

                                    getText (y) +

                                    "</div>" +
                                "</div>" +
                            "</div>" +
            
                        "</div>" +

                "</div>";

            systemCount++;
        }    
    }
}

function hideContentRectangles () {

    document.getElementById("basicSupportedFeatures").style.display = "none";
    document.getElementById("liveData").style.display = "none";
    document.getElementById("enhancedDiagnostics").style.display = "none";
    document.getElementById("enhancedAdditionalFeatures").style.display = "none";   
    document.getElementById("serviceFeatures").style.display = "none";


    document.getElementById("restrictionDisplayContent").classList.toggle("active", false);
    document.getElementById("unknownEnhancedContent").classList.toggle("active", false);
    document.getElementById("obdUnsupportedContent").classList.toggle("active", false);
    document.getElementById("messageDisplayContent").classList.toggle("active", false);
}

function hideLabel (labelTitle) {

    document.getElementById(labelTitle).style.fontSize = "16px";
    document.getElementById(labelTitle).style.paddingTop = "8px";
    document.getElementById(labelTitle).style.paddingBottom = "8px";
    document.getElementById(labelTitle + " label").style.display = "none";
}


function fetchLiveData (PID) {

    jQuery.ajax ({
        type: 'GET',
        url: 'https://obd2blue.bluedriver.com/cgi-bin/pids.pl?pids=' + PID + '&format=full',

        dataType: 'jsonp',
        success: function(data) 
        {
            document.getElementById("liveDataContent").innerHTML =
                "For a detailed explanation of various live data sources, please visit our <a href=\"https://www.bluedriver.com/livedata\" target=\"_blank\">Live Data Guide</a>.<br>";

            let pidLength = (data["pids"].length)/2;

            let categoryList = [];

            for (let x in data["pids"])
            {
                for (let y in data["pids"][x]["categories"])
                {
                    if (!categoryList.includes(data["pids"][x]["categories"][y]))
                    {
                        let stringTemp = "";

                        let catName = data["pids"][x]["categories"][y];
                        
                        stringTemp +=  "<div class=\"pid-content-flex\">" + "<div class=\"pid-content-box\"><div class=\"pid-content-title\"><div class=\"pid-content-expander\">+</div>" + data["pids"][x]["categories"][y] +
                                    "</div><div class=\"pid-content-tooltip\"><div class=\"text-tooltip-icon\"></div><div class=\"text-tooltip-container\"><div class=\"text-tooltip\">" + data["categories"][catName] + ".</div></div></div></div><div class=\"pid-system-divider\"></div>" +
                                    "<div class=\"pid-content-description full-format\">"; 
                                    

                        for (let z in data["pids"])
                        {  
                            for (let w in data["pids"][z]["categories"])
                            {
                                if (data["pids"][x]["categories"][y] == data["pids"][z]["categories"][w])
                                {
                                    stringTemp += "• " + data["pids"][z]["description"] + "<br>";
                                }
                            }
                        }
                        

                        stringTemp += "</div></div>";

                        document.getElementById("liveDataPids").innerHTML += stringTemp;

                        categoryList.push(data["pids"][x]["categories"][y]);

                    }
                }
            }    

            addPIDExpanders();

        }

    });

}

function fetchServiceFeatures(make) {

    document.getElementById("serviceFeatures").style.display = "none";
    document.getElementById("active-service-features").style.display = "none";
    document.getElementById("passive-service-features").style.display = "none";
    document.getElementById("oil-light-reset").style.display = "none";
    document.getElementById("tpms-light-reset").style.display = "none";

    jQuery.ajax ({
        type: 'GET',
        url: 'https://obd2blue.bluedriver.com/cgi-bin/reset-instructions.pl?parent=' + make,

        dataType: 'jsonp',
        success: function(res) 
        {
            if ((res["oil"] === undefined) && (res["tpms"] === undefined) && (data[makeSelect.value][modelSelect.value][yearSelect.value][engineSelect.value]["Other"]["Battery"] === undefined))
            {
            }

            else 
            {
                if (res["oil"] !== undefined)
                {
                    document.getElementById("oil-light-reset").style.display = "flex";
                    document.getElementById("passive-service-features").style.display = "block";
                }

                if (res["tpms"] !== undefined)
                {
                    document.getElementById("tpms-light-reset").style.display = "flex";
                    document.getElementById("passive-service-features").style.display = "block";
                }

                if (data[makeSelect.value][modelSelect.value][yearSelect.value][engineSelect.value]["Other"]["Battery"] !== undefined)
                {
                     document.getElementById("active-service-features").style.display = "block";
                }

            document.getElementById("serviceFeatures").style.display = "flex";
            }
        }
    });
}


function addPIDExpanders() {

    expanders = document.getElementsByClassName("pid-content-box");

    for (let i=0; i<expanders.length; i++)
    {

        if ((expanders[i].parentElement.children[2].innerHTML.split("<br>").length - 1) > 1)
        {
            expanders[i].addEventListener("click", function(e) {

                if (e.target.classList[0] == "text-tooltip-icon") {
                }

                else {
                    expanders[i].parentElement.children[2].classList.toggle("shown");

                    if (expanders[i].children[0].children[0].innerHTML == "+")
                    {
                        expanders[i].children[0].children[0].innerHTML = "-";
                    }

                    else if (expanders[i].children[0].children[0].innerHTML == "-")
                    {
                        expanders[i].children[0].children[0].innerHTML = "+";
                    }
                }
            });
        }

        else
        {
            expanders[i].children[0].children[0].innerHTML = "";
        }
    }
}



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["full-width-compatibility-9pin"] && !Shopify.designMode) return;
  try {
    

/*document.getElementById('shopify-section-page-title').style.height = "70px";*/



console.log("Test");

yearSelect = document.getElementById("year");
countrySelect = document.getElementById("country");
makeSelect = document.getElementById("make");
modelSelect = document.getElementById("model");
engineSelect = document.getElementById("engine");

yearSelect.selectedIndex = 0;
countrySelect.selectedIndex = 0;


for (let i = 2023; i >= 1996; i--) 
{
    yearSelect.add(new Option(i, i));
}

mmyeFlex = document.getElementById("mmye-flex");

let countryCode;

let option = document.createElement("option");
option.value = "";

countrySelect.addEventListener("change", function(e)   {

    mmyeFlex.style.display = "none";
    hideContentRectangles();

    document.getElementById("year").selectedIndex = "0"; 

    document.querySelectorAll('#make option').forEach(option => option.remove())
    makeSelect.add(new Option("Make", ""));

    document.querySelectorAll('#model option').forEach(option => option.remove())
    modelSelect.add(new Option("Model", ""));

    document.querySelectorAll('#engine option').forEach(option => option.remove())
    engineSelect.add(new Option("Engine", ""));   

    hideLabel("year");
    hideLabel("model");
    hideLabel("make");
    hideLabel("engine");     

    switch (countrySelect.value) {
        case 'US':
        case 'CA':
		case 'PR':
            mmyeFlex.style.display = "flex";
            document.getElementById("countryIncompatibleRectangle").style.display = "none";
            break;
        default:
            mmyeFlex.style.display = "none";
            document.getElementById("restrictionDisplayContent").classList.toggle("active", false);
            document.getElementById("unknownEnhancedContent").classList.toggle("active", false);
            document.getElementById("obdUnsupportedContent").classList.toggle("active", false);
            document.getElementById("messageDisplayContent").classList.toggle("active", false);

            document.getElementById("countryIncompatibleRectangle").style.display = "flex";

            hideLabel("year");
            hideLabel("model");
            hideLabel("make");
            hideLabel("engine");
    }
    
    switch (countrySelect.value) {
        case 'US':
        case 'CA':
            break;
        case 'MX':
        case 'HK':
        case 'NZ':
            document.getElementById("countryIncompatibleText").innerHTML = "<strong>Petrol &amp; Diesel:</strong> All <strong>2006</strong> or newer car &amp; light truck (i.e. SUVs, pickups, minivans, etc.) makes &amp; models work with BlueDriver.<p><strong>Enhanced codes</strong> (ABS, SRS, etc) are available for most compatible vehicles from GM, Ford, Chrysler, Toyota, Mazda, Mitsubishi, Mercedes-Benz, Hyundai, and Nissan.</p><p><strong>Repair Reports</strong> are available for vehicles with North American VINs only.</p>";
            break;
        case 'AL':
        case 'AD':
        case 'AT':
        case 'BY':
        case 'BE':
        case 'BA':
        case 'BG':
        case 'HR':
        case 'CY':
        case 'CZ':
        case 'DK':
        case 'EE':
        case 'FO':
        case 'FI':
        case 'FR':
        case 'DE':
        case 'GI':
        case 'GR':
        case 'HU':
        case 'IS':
        case 'IE':
        case 'IT':
        case 'LV':
        case 'LI':
        case 'LT':
        case 'LU':
        case 'MK':
        case 'MT':
        case 'MD':
        case 'MC':
        case 'NL':
        case 'NO':
        case 'PL':
        case 'PT':
        case 'RO':
        case 'RU':
        case 'SM':
        case 'RS':
        case 'SK':
        case 'SI':
        case 'ES':
        case 'SE':
        case 'CH':
        case 'UA':
        case 'GB':
        case 'VA':
        case 'YU':
        case 'IM':
        case 'RS':
        case 'ME':
            document.getElementById("countryIncompatibleText").innerHTML = "<strong>Petrol:</strong> All <strong>2001</strong> or newer car &amp; light truck (i.e. SUVs, pickups, minivans, etc.) makes &amp; models work with BlueDriver.<p><strong>Diesel:</strong> All <strong>2004</strong> or newer car &amp; light truck (i.e. SUVs, pickups, minivans, etc.) makes &amp; models work with BlueDriver.</p><p><strong>Enhanced codes</strong> (ABS, SRS, etc) are available for most compatible vehicles from GM, Ford, Chrysler, Toyota, Mazda, Mitsubishi, Mercedes-Benz, Hyundai, and Nissan.</p><p><strong>Repair Reports</strong> are not currently available in Europe.</p>";
            break;
        case 'AR':
        case 'KR':
            document.getElementById("countryIncompatibleText").innerHTML = "<strong>Petrol &amp; Diesel:</strong> All <strong>2009</strong> or newer car &amp; light truck (i.e. SUVs, pickups, minivans, etc.) makes &amp; models work with BlueDriver.<p><strong>Enhanced codes</strong> (ABS, SRS, etc) are available for most compatible vehicles from GM, Ford, Chrysler, Toyota, Mazda, Mitsubishi, Mercedes-Benz, Hyundai, and Nissan.</p><p><strong>Repair Reports</strong> are available for vehicles with North American VINs only.</p>";
            break;
        case 'BR':
            document.getElementById("countryIncompatibleText").innerHTML = "<strong>Petrol:</strong> All <strong>2010</strong> or newer car &amp; light truck (i.e. SUVs, pickups, minivans, etc.) makes &amp; models work with BlueDriver.<p><strong>Diesel:</strong> Sorry, there is no published standard for OBD2-compliance for diesel vehicles in your country (which BlueDriver uses for data), therefore the support may vary from vehicle to vehicle. If the vehicle has a sticker in the engine bay or states in the owners manual that it is OBD2-compliant (or EOBD-compliant), it will work with BlueDriver.</p><p><strong>Enhanced codes</strong> (ABS, SRS, etc) are available for most compatible vehicles from GM, Ford, Chrysler, Toyota, Mazda, Mitsubishi, Mercedes-Benz, Hyundai, and Nissan.</p><p><strong>Repair Reports</strong> are available for vehicles with North American VINs only.</p>";
            break;
        case 'IL':
            document.getElementById("countryIncompatibleText").innerHTML = "<strong>Petrol &amp; Diesel:</strong> All <strong>2003</strong> or newer car &amp; light truck (i.e. SUVs, pickups, minivans, etc.) makes &amp; models work with BlueDriver.<p><strong>Enhanced codes</strong> (ABS, SRS, etc) are available for most compatible vehicles from GM, Ford, Chrysler, Toyota, Mazda, Mitsubishi, Mercedes-Benz, Hyundai, and Nissan.</p><p><strong>Repair Reports</strong> are available for vehicles with North American VINs only.</p>";
            break;
        case 'CN':
            document.getElementById("countryIncompatibleText").innerHTML = "<strong>Petrol:</strong> All <strong>2009</strong> or newer car &amp; light truck (i.e. SUVs, pickups, minivans, etc.) makes &amp; models work with BlueDriver.<p><strong>Diesel:</strong> All <strong>2011</strong> or newer car &amp; light truck (i.e. SUVs, pickups, minivans, etc.) makes &amp; models work with BlueDriver.</p><p><strong>Enhanced codes</strong> (ABS, SRS, etc) are available for most compatible vehicles from GM, Ford, Chrysler, Toyota, Mazda, Mitsubishi, Mercedes-Benz, Hyundai, and Nissan.</p><p><strong>Repair Reports</strong> are available for vehicles with North American VINs only.</p>";
            break;
        case 'IN':
        case 'TH':
            document.getElementById("countryIncompatibleText").innerHTML = "<strong>Petrol &amp; Diesel:</strong> All <strong>2013</strong> or newer car &amp; light truck (i.e. SUVs, pickups, minivans, etc.) makes &amp; models work with BlueDriver.<p><strong>Enhanced codes</strong> (ABS, SRS, etc) are available for most compatible vehicles from GM, Ford, Chrysler, Toyota, Mazda, Mitsubishi, Mercedes-Benz, Hyundai, and Nissan.</p><p><strong>Repair Reports</strong> are available for vehicles with North American VINs only.</p>";
            break;
        case 'JP':
            document.getElementById("countryIncompatibleText").innerHTML = "<strong>Petrol &amp; Diesel:</strong> All <strong>2010</strong> or newer car &amp; light truck (i.e. SUVs, pickups, minivans, etc.) makes &amp; models work with BlueDriver.<p><strong>Enhanced codes</strong> (ABS, SRS, etc) are available for most compatible vehicles from GM, Ford, Chrysler, Toyota, Mazda, Mitsubishi, Mercedes-Benz, Hyundai, and Nissan.</p><p><strong>Repair Reports</strong> are available for vehicles with North American VINs only.</p>";
            break;
        case 'TW':
            document.getElementById("countryIncompatibleText").innerHTML = "<strong>Petrol &amp; Diesel:</strong> All <strong>2008</strong> or newer car &amp; light truck (i.e. SUVs, pickups, minivans, etc.) makes &amp; models work with BlueDriver.<p><strong>Enhanced codes</strong> (ABS, SRS, etc) are available for most compatible vehicles from GM, Ford, Chrysler, Toyota, Mazda, Mitsubishi, Mercedes-Benz, Hyundai, and Nissan.</p><p><strong>Repair Reports</strong> are available for vehicles with North American VINs only.</p>";
            break;
        case 'AU':
            document.getElementById("countryIncompatibleText").innerHTML = "<strong>Petrol:</strong> All <strong>2006</strong> or newer car &amp; light truck (i.e. SUVs, pickups, minivans, etc.) makes &amp; models work with BlueDriver.<p><strong>Diesel:</strong> All <strong>2007</strong> or newer car &amp; light truck (i.e. SUVs, pickups, minivans, etc.) makes &amp; models work with BlueDriver.</p><p><strong>Enhanced codes</strong> (ABS, SRS, etc) are available for most compatible vehicles from GM, Ford, Chrysler, Toyota, Mazda, Mitsubishi, Mercedes-Benz, Hyundai, and Nissan.</p><p><strong>Repair Reports</strong> are available for vehicles with North American VINs only.</p>";
            break;
        case '':
            break;
        default:
            document.getElementById("countryIncompatibleText").innerHTML = "BlueDriver is compatible with all vehicles that support OBDII diagnostics. However, OBDII compliance varies depending on geographical region and year. For example, North America began requiring OBDII compliance in 1996, and Europe in 2001 (2004 for diesel).<br><br>"
            + "<strong>Unfortunately, " + countrySelect.options[countrySelect.selectedIndex].text.toUpperCase() + " does not require the use of OBDII diagnostics in locally sold vehicles. As a result, we cannot guarantee that any vehicle sold in this region will be compatible with BlueDriver.</strong><br><br>"
            + "<strong>If your vehicle has a sticker or plate in the engine bay that states 'OBDII Certified' or 'EOBD Compatible' your vehicle will support:</strong><br><br>";
    }
});

yearSelect.addEventListener("change", function(e)   { 

    hideContentRectangles();

    document.querySelectorAll('#make option').forEach(option => option.remove())
    makeSelect.add(new Option("Make", ""));

    document.querySelectorAll('#model option').forEach(option => option.remove())
    modelSelect.add(new Option("Model", ""));

    document.querySelectorAll('#engine option').forEach(option => option.remove())
    engineSelect.add(new Option("Engine", ""));

    hideLabel("engine");
    hideLabel("model");
    hideLabel("make");

    let makesList = [];

    for (let x in data)  
    {
        for (let y in data[x])
        {
            for (let z in data[x][y])
            {
                if (z === yearSelect.value)
                {
                    if (!makesList.includes(x))
                    {
                        makeSelect.add(new Option(x, x));                                        
                        makesList.push(x);
                    }
                }
            }
        }         
    }
    

    if (yearSelect.value == "")
    {
        hideLabel("year");
    }

    else
    {
        document.getElementById("year").style.fontSize = "14px";
        document.getElementById("year").style.paddingTop = "14px";
        document.getElementById("year").style.paddingBottom = "2px";
        document.getElementById("year label").style.display = "block";
    }
});

makeSelect.addEventListener("change", function(e) { 

    hideContentRectangles();

    document.querySelectorAll('#model option').forEach(option => option.remove())
    modelSelect.add(new Option("Model", ""));

    document.querySelectorAll('#engine option').forEach(option => option.remove())
    engineSelect.add(new Option("Engine", ""));

    hideLabel("engine");
    hideLabel("model");

    for (let y in data[makeSelect.value])
    {
        for (let z in data[makeSelect.value][y]) 
        {
            if ((data[makeSelect.value][y][yearSelect.value] == data[makeSelect.value][y][z]))
            {
                modelSelect.add(new Option(y, y));
            }
        }
    }

    if (makeSelect.value == "")
    {
        hideLabel("year");
    }

    else
    {
        document.getElementById("make").style.fontSize = "14px";
        document.getElementById("make").style.paddingTop = "14px";
        document.getElementById("make").style.paddingBottom = "2px";
        document.getElementById("make label").style.display = "block";        
    }
});

modelSelect.addEventListener("change", function(e) {

    hideContentRectangles();

    document.querySelectorAll('#engine option').forEach(option => option.remove())
    engineSelect.add(new Option("Engine", ""));

    hideLabel("engine");

    if (data[makeSelect.value][modelSelect.value] !== undefined)
    {
        for (let z in data[makeSelect.value][modelSelect.value][yearSelect.value]) 
        {
            engineSelect.add(new Option(z, z));
        }
    }
        
    if (modelSelect.value == "")
    {
        hideLabel("year");
    }

    else
    {
        document.getElementById("model").style.fontSize = "14px";
        document.getElementById("model").style.paddingTop = "14px";
        document.getElementById("model").style.paddingBottom = "2px";
        document.getElementById("model label").style.display = "block";        
    }
});

engineSelect.addEventListener("input", function(e) {

    let engineData = data[makeSelect.value][modelSelect.value][yearSelect.value][engineSelect.value];
    let serviceData = makeSelect.value;

    hideContentRectangles();

    document.getElementById("additional-systems-title").style.display = "none";

    document.getElementById("serviceFeatures").style.display = "none";

    document.getElementById("liveDataContent").innerHTML = "";
    document.getElementById("liveDataPids").innerHTML = "";
    document.getElementById("restrictionDisplayContent").innerHTML = "";
    

    if (engineSelect.options[engineSelect.selectedIndex].text == "Engine") 
    {
        hideContentRectangles();
    }

    else 
    {
        document.getElementById("mmye-display").innerHTML = 
         "<span class='divider'>"+ countrySelect.options[countrySelect.selectedIndex].text+ " </span> "
        +  "<span class='divider'>"+yearSelect.options[yearSelect.selectedIndex].text + " </span> "
        +  "<span class='divider'>"+makeSelect.options[makeSelect.selectedIndex].text + " </span> "
        +  "<span class='divider'>"+modelSelect.options[modelSelect.selectedIndex].text + " </span> "
        +  "<span class='divider'>"+engineSelect.options[engineSelect.selectedIndex].text +" </span> ";
       

        document.getElementById("selector-flex").style.display = "none";

        document.getElementById("mmye-display").style.display = "flex";
        document.getElementById("mmye-edit-button").style.display = "flex";

        if (engineData["Message"] !== null)
        {
            document.getElementById("messageDisplayContent").innerHTML = "<strong>COMPATIBILITY NOTE: </strong>" + engineData["Message"];
            document.getElementById("messageDisplayContent").classList.toggle("active", true);
        }
            
        else 
        {
            document.getElementById("messageDisplayContent").classList.toggle("active", false);  
            document.getElementById("messageDisplayContent").innerHTML = "";              
        }

        if (engineData["OBD"] === false)
        {
            document.getElementById("obdUnsupportedContent").classList.toggle("active",true);           
        }

        else 
        {
            document.getElementById("obdUnsupportedContent").classList.toggle("active",false);

            fetchServiceFeatures(serviceData);

            if ((engineData["PID"] === null) || (engineData["PID"] === "0"))
            {
                document.getElementById("liveDataContent").innerHTML = 
                "Your vehicle supports live data, but we do not currently have a list of what datapoints are available. " +
                "Your vehicle will provide this list to the scanner on connection. If you have any questions, please contact support any time.";
            }

            else 
            {
                fetchLiveData(engineData["PID"]);
            }

            if (engineData["Restrictions"] !== null)
            {
                if (engineData["Enhanced"] === true)
                {
                    let restrictionList = "<strong>";

                    document.getElementById('restrictionDisplayContent').style.border = "1px solid #b21515";
                    document.getElementById('restrictionDisplayContent').style.color = "#b21515";                    

                    for (let x in engineData["Restrictions"])
                    {

                        if ((engineData["Restrictions"][x] === ("Canada" || "CA")) && (countrySelect.value === "CA"))
                        {
                            document.getElementById('restrictionDisplayContent').style.border = "1px solid #202326";
                            document.getElementById('restrictionDisplayContent').style.color = "black";                            
                        }

                        if ((engineData["Restrictions"][x] === ("United States" || "US")) && (countrySelect.value === "US"))
                        {
                            document.getElementById('restrictionDisplayContent').style.border = "1px solid #202326";
                            document.getElementById('restrictionDisplayContent').style.color = "black";                            
                        }

                        if (x == 0)
                        {
                            restrictionList += engineData["Restrictions"][x];
                        }
                        
                        else
                        {
                            restrictionList += " & " + engineData["Restrictions"][x];
                        }

                    }              
                    
                    restrictionList += "</strong>";
                        
                    document.getElementById("restrictionDisplayContent").classList.toggle("active", true);

                    document.getElementById("restrictionDisplayContent").innerHTML =
                    "<strong>REGION NOTE: </strong>Enhanced diagnostic features are available in " + restrictionList +
                    ". Outside of these regions, all features will be available except enhanced systems (ABS, Airbags, etc.)"
                }
            }

            if ((engineData["Enhanced"] === false) || (engineData === undefined))
            {
                document.getElementById("unknownEnhancedContent").classList.toggle("active", false);
                document.getElementById("basicSupportedFeatures").style.display = "flex";
                document.getElementById("liveData").style.display = "flex";
                document.getElementById("enhancedDiagnostics").style.display = "none";
                document.getElementById("enhancedAdditionalFeatures").style.display = "none";
            }

            else
            {
                if (engineData["Systems"] === null)
                {
                    document.getElementById("unknownEnhancedContent").classList.toggle("active", true);
                    document.getElementById("enhancedDiagnostics").style.display = "none";
                    document.getElementById("enhancedAdditionalFeatures").style.display = "none";
                    document.getElementById("basicSupportedFeatures").style.display = "flex";
                }

                else if (engineData["Systems"] === undefined)
                {                    
                    document.getElementById("unknownEnhancedContent").classList.toggle("active", false);
                    document.getElementById("enhancedDiagnostics").style.display = "none";
                    document.getElementById("enhancedAdditionalFeatures").style.display = "flex";
                    document.getElementById("basicSupportedFeatures").style.display = "none";
                }

                else
                {
                    systemAvailabilityUpdate(engineData);
                    
                    document.getElementById("enhancedDiagnostics").style.display = "flex";
                    document.getElementById("enhancedAdditionalFeatures").style.display = "flex";
                    document.getElementById("basicSupportedFeatures").style.display = "none";
                }

                document.getElementById("liveData").style.display = "flex";
            }
        }
    }

    if (engineSelect.value == "")
    {
        hideLabel("year");     
    }

    else
    {
        document.getElementById("engine").style.fontSize = "14px";
        document.getElementById("engine").style.paddingTop = "14px";
        document.getElementById("engine").style.paddingBottom = "2px";
        document.getElementById("engine label").style.display = "block";        
    }
});

document.getElementById("countryRequirementText").addEventListener("click", function(e) { 

    document.getElementById("country-requirement-display").classList.toggle("shrunk", true);
});

document.getElementById("country-requirement-display-close").addEventListener("click", function(e) { 

    document.getElementById("country-requirement-display").classList.toggle("shrunk", false);
});

window.addEventListener("load", function(e) {
});

document.getElementById("mmye-edit-button").addEventListener("click", function(e) {
    document.getElementById("selector-flex").style.display = "flex";
    document.getElementById("mmye-display").style.display = "none";
    document.getElementById("mmye-edit-button").style.display = "none";
});

function getText (system) {
    let additionalSystemText;

        switch (system) { 
            case 'Battery and Power': 
                additionalSystemText = "Power distribution and battery health monitoring systems.";
                break;
            case 'Doors and Windows':
                additionalSystemText = "Door controls and locks, power windows, power sliding/rear doors, convertible tops, etc.";
                break;
            case 'Driver Assist and Active Safety':
                additionalSystemText = "Active cruise control, lane assist, emergency braking, pedestrian detection, etc.";
                break;        
            case 'Driver Information and Control':
                additionalSystemText = "Instrument panel, displays/screens, buttons and control panels, etc.";
                break;        
            case 'Entertainment and Navigation':
                additionalSystemText = "Stereo, navigation systems, amplifiers, CD changers, etc.";
                break;        
            case 'Heat and Air Conditioning':
                additionalSystemText = "Heat, air conditioning, climate control.";
                break;        
            case 'Lights':
                additionalSystemText = "Headlights, interior lighting.";
                break;        
            case 'Premium Vehicle Options':
                additionalSystemText = "Wifi hotspots, sun shades, active noise cancellation, automatic running boards, etc.";
                break;        
            case 'Seats and Mirrors':
                additionalSystemText = "Heated and power seats, heated mirrors, mirror controls, etc.";
                break;        
            case 'Security & Keyless Entry':
                additionalSystemText = "Keyless entry, immobilizers, remote starters, etc.";
                break;        
            case 'Trailer and Auxiliary Equipment':
                additionalSystemText = "Trailer brakes, power take-offs, etc.";
                break;
            case 'Vehicle Control and Suspension':
                additionalSystemText = "Power steering, active/electronic suspension or dampeners, etc.";
                break;                        
            default: 
    };

    return additionalSystemText;
}

function systemAvailabilityUpdate(data) {

    document.getElementById("serviceFeatures").style.display = "none";
    document.getElementById("active-service-features").style.display = "none";

    document.getElementById("additional-systems-flex").innerHTML = "";

    document.getElementById("additional-systems-title").style.display = "none";

    for (let x in data["Systems"]["Primary"])
    {
        if (data["Systems"]["Primary"][x] === true)
        {
            document.getElementById(x + " box").style.display = "flex";

            if (x === "Engine")
            {
                document.getElementById(x).innerHTML = "<div class=\"primary-systems-check check-mark check-mark\"></div>";

                document.getElementById(x + " subtext").style.display = "block";    

                document.getElementById(x + " subtext").innerHTML = "Systems related to the operation of the engine - " + 
                "engine/powertrain controller, electronic fuel pump, starter, etc.";

                document.getElementById(x + " subtext alt").style.display = "none";
            }
            
            else 
            {
                document.getElementById(x).innerHTML = "<div class=\"primary-systems-check check-mark check-mark\"></div>";

                document.getElementById(x + " box").classList.toggle("unavailable", false); 

                document.getElementById(x + " title").classList.toggle("unavailable", false); 

                document.getElementById(x + " subtext").style.display = "block";

                document.getElementById(x + " subtext alt").style.display = "none";
            }
        }

        else if (data["Systems"]["Primary"][x] === false)
        {
            document.getElementById(x + " box").style.display = "flex";

            if (x === "Engine")
            {
                document.getElementById(x).innerHTML = "<div class=\"primary-systems-check check-mark check-mark\"></div>";

                document.getElementById(x + " subtext").style.display = "block";    

                document.getElementById(x + " subtext").innerHTML = "<strong>Note:</strong> This vehicle " +
                "only supports Check Engine Light codes from the engine module.";

                document.getElementById(x + " subtext alt").style.display = "none";
            }

            else 
            { 
                document.getElementById(x).innerHTML = "<div class=\"primary-systems-cross cross-mark\"></div>";

                document.getElementById(x + " box").classList.toggle("unavailable", true); 

                document.getElementById(x + " title").classList.toggle("unavailable", true); 

                document.getElementById(x + " subtext alt").innerHTML = "Not supported by this vehicle.";

                document.getElementById(x + " subtext").style.display = "none";

                document.getElementById(x + " subtext alt").style.display = "block";
            }
        }

        else if (data["Systems"]["Primary"][x] === null)
        {
            document.getElementById(x + " box").style.display = "none";

            document.getElementById(x + " title").classList.toggle("unavailable", true); 

            document.getElementById(x).innerHTML = "<div class=\"system-not-available\">N/A</div>";

            document.getElementById(x + " subtext alt").innerHTML = "Your vehicle does not have this system.";

            document.getElementById(x + " subtext").style.display = "none";

            document.getElementById(x + " subtext alt").style.display = "block";            
        }

        if (data["Systems"]["Primary"]["Hybrid and EV"] === true)
        {
            document.getElementById("Hybrid and EV box").style.display = "flex";
        }

        else 
        {       
            document.getElementById("Hybrid and EV box").style.display = "none";
        }
    }

    let systemCount = 0;

    for (let y in data["Systems"]["Secondary"])
    {
        if (data["Systems"]["Secondary"][y] == true) 
        {
            document.getElementById("additional-systems-title").style.display = "flex";

            if (systemCount == 0) 
            {
                divider = "";
            }

            else if (systemCount == 1)
            {
                divider = "<div class=\"system-divider-alt\"></div>";
            }
            
            else
            {
                divider = "<div class=\"system-divider\"></div>";
            }


            document.getElementById("additional-systems-flex").innerHTML += 

                "<div class=\"additional-systems-box\">" + divider +

                        "<div class=\"additional-systems-field\">" +
                            
                            "<div class=\"additional-systems-text\">" +

                                "<div class=\"additional-systems-check check-mark check-mark\"></div>" + y + "</div>" +

                            "<div class=\"additional-systems-tooltip\">" +
                                "<div class=\"text-tooltip-icon\"></div>" +
                                "<div class=\"text-tooltip-container\">" +
                                    "<div class=\"text-tooltip\">" +

                                    getText (y) +

                                    "</div>" +
                                "</div>" +
                            "</div>" +
            
                        "</div>" +

                "</div>";

            systemCount++;
        }    
    }
}

function hideContentRectangles () {

    document.getElementById("basicSupportedFeatures").style.display = "none";
    document.getElementById("liveData").style.display = "none";
    document.getElementById("enhancedDiagnostics").style.display = "none";
    document.getElementById("enhancedAdditionalFeatures").style.display = "none";   
    document.getElementById("serviceFeatures").style.display = "none";


    document.getElementById("restrictionDisplayContent").classList.toggle("active", false);
    document.getElementById("unknownEnhancedContent").classList.toggle("active", false);
    document.getElementById("obdUnsupportedContent").classList.toggle("active", false);
    document.getElementById("messageDisplayContent").classList.toggle("active", false);
}

function hideLabel (labelTitle) {

    document.getElementById(labelTitle).style.fontSize = "16px";
    document.getElementById(labelTitle).style.paddingTop = "8px";
    document.getElementById(labelTitle).style.paddingBottom = "8px";
    document.getElementById(labelTitle + " label").style.display = "none";
}


function fetchLiveData (PID) {

    jQuery.ajax ({
        type: 'GET',
        url: 'https://obd2blue.bluedriver.com/cgi-bin/pids.pl?pids=' + PID + '&format=full',

        dataType: 'jsonp',
        success: function(data) 
        {
            document.getElementById("liveDataContent").innerHTML =
                "For a detailed explanation of various live data sources, please visit our <a href=\"https://www.bluedriver.com/livedata\" target=\"_blank\">Live Data Guide</a>.<br>";

            let pidLength = (data["pids"].length)/2;

            let categoryList = [];

            for (let x in data["pids"])
            {
                for (let y in data["pids"][x]["categories"])
                {
                    if (!categoryList.includes(data["pids"][x]["categories"][y]))
                    {
                        let stringTemp = "";

                        let catName = data["pids"][x]["categories"][y];
                        
                        stringTemp +=  "<div class=\"pid-content-flex\">" + "<div class=\"pid-content-box\"><div class=\"pid-content-title\"><div class=\"pid-content-expander\">+</div>" + data["pids"][x]["categories"][y] +
                                    "</div><div class=\"pid-content-tooltip\"><div class=\"text-tooltip-icon\"></div><div class=\"text-tooltip-container\"><div class=\"text-tooltip\">" + data["categories"][catName] + ".</div></div></div></div><div class=\"pid-system-divider\"></div>" +
                                    "<div class=\"pid-content-description full-format\">"; 
                                    

                        for (let z in data["pids"])
                        {  
                            for (let w in data["pids"][z]["categories"])
                            {
                                if (data["pids"][x]["categories"][y] == data["pids"][z]["categories"][w])
                                {
                                    stringTemp += "• " + data["pids"][z]["description"] + "<br>";
                                }
                            }
                        }
                        

                        stringTemp += "</div></div>";

                        document.getElementById("liveDataPids").innerHTML += stringTemp;

                        categoryList.push(data["pids"][x]["categories"][y]);

                    }
                }
            }    

            addPIDExpanders();

        }

    });

}

function fetchServiceFeatures(make) {

    document.getElementById("serviceFeatures").style.display = "none";
    document.getElementById("active-service-features").style.display = "none";
    document.getElementById("passive-service-features").style.display = "none";
    document.getElementById("oil-light-reset").style.display = "none";
    document.getElementById("tpms-light-reset").style.display = "none";

    jQuery.ajax ({
        type: 'GET',
        url: 'https://obd2blue.bluedriver.com/cgi-bin/reset-instructions.pl?parent=' + make,

        dataType: 'jsonp',
        success: function(res) 
        {
            if ((res["oil"] === undefined) && (res["tpms"] === undefined) && (data[makeSelect.value][modelSelect.value][yearSelect.value][engineSelect.value]["Other"]["Battery"] === undefined))
            {
            }

            else 
            {
                if (res["oil"] !== undefined)
                {
                    document.getElementById("oil-light-reset").style.display = "flex";
                    document.getElementById("passive-service-features").style.display = "block";
                }

                if (res["tpms"] !== undefined)
                {
                    document.getElementById("tpms-light-reset").style.display = "flex";
                    document.getElementById("passive-service-features").style.display = "block";
                }

                if (data[makeSelect.value][modelSelect.value][yearSelect.value][engineSelect.value]["Other"]["Battery"] !== undefined)
                {
                     document.getElementById("active-service-features").style.display = "block";
                }

            document.getElementById("serviceFeatures").style.display = "flex";
            }
        }
    });
}


function addPIDExpanders() {

    expanders = document.getElementsByClassName("pid-content-box");

    for (let i=0; i<expanders.length; i++)
    {

        if ((expanders[i].parentElement.children[2].innerHTML.split("<br>").length - 1) > 1)
        {
            expanders[i].addEventListener("click", function(e) {

                if (e.target.classList[0] == "text-tooltip-icon") {
                }

                else {
                    expanders[i].parentElement.children[2].classList.toggle("shown");

                    if (expanders[i].children[0].children[0].innerHTML == "+")
                    {
                        expanders[i].children[0].children[0].innerHTML = "-";
                    }

                    else if (expanders[i].children[0].children[0].innerHTML == "-")
                    {
                        expanders[i].children[0].children[0].innerHTML = "+";
                    }
                }
            });
        }

        else
        {
            expanders[i].children[0].children[0].innerHTML = "";
        }
    }
}



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["full-width-compatibility"] && !Shopify.designMode) return;
  try {
    

/*document.getElementById('shopify-section-page-title').style.height = "70px";*/



console.log("Test");

yearSelect = document.getElementById("year");
countrySelect = document.getElementById("country");
makeSelect = document.getElementById("make");
modelSelect = document.getElementById("model");
engineSelect = document.getElementById("engine");

yearSelect.selectedIndex = 0;
countrySelect.selectedIndex = 0;


for (let i = 2023; i >= 1996; i--) 
{
    yearSelect.add(new Option(i, i));
}

mmyeFlex = document.getElementById("mmye-flex");

let countryCode;

let option = document.createElement("option");
option.value = "";

countrySelect.addEventListener("change", function(e)   {

    mmyeFlex.style.display = "none";
    hideContentRectangles();

    document.getElementById("year").selectedIndex = "0"; 

    document.querySelectorAll('#make option').forEach(option => option.remove())
    makeSelect.add(new Option("Make", ""));

    document.querySelectorAll('#model option').forEach(option => option.remove())
    modelSelect.add(new Option("Model", ""));

    document.querySelectorAll('#engine option').forEach(option => option.remove())
    engineSelect.add(new Option("Engine", ""));   

    hideLabel("year");
    hideLabel("model");
    hideLabel("make");
    hideLabel("engine");     

    switch (countrySelect.value) {
        case 'US':
        case 'CA':
		case 'PR':
            mmyeFlex.style.display = "flex";
            document.getElementById("countryIncompatibleRectangle").style.display = "none";
            break;
        default:
            mmyeFlex.style.display = "none";
            document.getElementById("restrictionDisplayContent").classList.toggle("active", false);
            document.getElementById("unknownEnhancedContent").classList.toggle("active", false);
            document.getElementById("obdUnsupportedContent").classList.toggle("active", false);
            document.getElementById("messageDisplayContent").classList.toggle("active", false);

            document.getElementById("countryIncompatibleRectangle").style.display = "flex";

            hideLabel("year");
            hideLabel("model");
            hideLabel("make");
            hideLabel("engine");
    }
    
    switch (countrySelect.value) {
        case 'US':
        case 'CA':
            break;
        case 'MX':
        case 'HK':
        case 'NZ':
            document.getElementById("countryIncompatibleText").innerHTML = "<strong>Petrol &amp; Diesel:</strong> All <strong>2006</strong> or newer car &amp; light truck (i.e. SUVs, pickups, minivans, etc.) makes &amp; models work with BlueDriver.<p><strong>Enhanced codes</strong> (ABS, SRS, etc) are available for most compatible vehicles from GM, Ford, Chrysler, Toyota, Mazda, Mitsubishi, Mercedes-Benz, Hyundai, and Nissan.</p><p><strong>Repair Reports</strong> are available for vehicles with North American VINs only.</p>";
            break;
        case 'AL':
        case 'AD':
        case 'AT':
        case 'BY':
        case 'BE':
        case 'BA':
        case 'BG':
        case 'HR':
        case 'CY':
        case 'CZ':
        case 'DK':
        case 'EE':
        case 'FO':
        case 'FI':
        case 'FR':
        case 'DE':
        case 'GI':
        case 'GR':
        case 'HU':
        case 'IS':
        case 'IE':
        case 'IT':
        case 'LV':
        case 'LI':
        case 'LT':
        case 'LU':
        case 'MK':
        case 'MT':
        case 'MD':
        case 'MC':
        case 'NL':
        case 'NO':
        case 'PL':
        case 'PT':
        case 'RO':
        case 'RU':
        case 'SM':
        case 'RS':
        case 'SK':
        case 'SI':
        case 'ES':
        case 'SE':
        case 'CH':
        case 'UA':
        case 'GB':
        case 'VA':
        case 'YU':
        case 'IM':
        case 'RS':
        case 'ME':
            document.getElementById("countryIncompatibleText").innerHTML = "<strong>Petrol:</strong> All <strong>2001</strong> or newer car &amp; light truck (i.e. SUVs, pickups, minivans, etc.) makes &amp; models work with BlueDriver.<p><strong>Diesel:</strong> All <strong>2004</strong> or newer car &amp; light truck (i.e. SUVs, pickups, minivans, etc.) makes &amp; models work with BlueDriver.</p><p><strong>Enhanced codes</strong> (ABS, SRS, etc) are available for most compatible vehicles from GM, Ford, Chrysler, Toyota, Mazda, Mitsubishi, Mercedes-Benz, Hyundai, and Nissan.</p><p><strong>Repair Reports</strong> are not currently available in Europe.</p>";
            break;
        case 'AR':
        case 'KR':
            document.getElementById("countryIncompatibleText").innerHTML = "<strong>Petrol &amp; Diesel:</strong> All <strong>2009</strong> or newer car &amp; light truck (i.e. SUVs, pickups, minivans, etc.) makes &amp; models work with BlueDriver.<p><strong>Enhanced codes</strong> (ABS, SRS, etc) are available for most compatible vehicles from GM, Ford, Chrysler, Toyota, Mazda, Mitsubishi, Mercedes-Benz, Hyundai, and Nissan.</p><p><strong>Repair Reports</strong> are available for vehicles with North American VINs only.</p>";
            break;
        case 'BR':
            document.getElementById("countryIncompatibleText").innerHTML = "<strong>Petrol:</strong> All <strong>2010</strong> or newer car &amp; light truck (i.e. SUVs, pickups, minivans, etc.) makes &amp; models work with BlueDriver.<p><strong>Diesel:</strong> Sorry, there is no published standard for OBD2-compliance for diesel vehicles in your country (which BlueDriver uses for data), therefore the support may vary from vehicle to vehicle. If the vehicle has a sticker in the engine bay or states in the owners manual that it is OBD2-compliant (or EOBD-compliant), it will work with BlueDriver.</p><p><strong>Enhanced codes</strong> (ABS, SRS, etc) are available for most compatible vehicles from GM, Ford, Chrysler, Toyota, Mazda, Mitsubishi, Mercedes-Benz, Hyundai, and Nissan.</p><p><strong>Repair Reports</strong> are available for vehicles with North American VINs only.</p>";
            break;
        case 'IL':
            document.getElementById("countryIncompatibleText").innerHTML = "<strong>Petrol &amp; Diesel:</strong> All <strong>2003</strong> or newer car &amp; light truck (i.e. SUVs, pickups, minivans, etc.) makes &amp; models work with BlueDriver.<p><strong>Enhanced codes</strong> (ABS, SRS, etc) are available for most compatible vehicles from GM, Ford, Chrysler, Toyota, Mazda, Mitsubishi, Mercedes-Benz, Hyundai, and Nissan.</p><p><strong>Repair Reports</strong> are available for vehicles with North American VINs only.</p>";
            break;
        case 'CN':
            document.getElementById("countryIncompatibleText").innerHTML = "<strong>Petrol:</strong> All <strong>2009</strong> or newer car &amp; light truck (i.e. SUVs, pickups, minivans, etc.) makes &amp; models work with BlueDriver.<p><strong>Diesel:</strong> All <strong>2011</strong> or newer car &amp; light truck (i.e. SUVs, pickups, minivans, etc.) makes &amp; models work with BlueDriver.</p><p><strong>Enhanced codes</strong> (ABS, SRS, etc) are available for most compatible vehicles from GM, Ford, Chrysler, Toyota, Mazda, Mitsubishi, Mercedes-Benz, Hyundai, and Nissan.</p><p><strong>Repair Reports</strong> are available for vehicles with North American VINs only.</p>";
            break;
        case 'IN':
        case 'TH':
            document.getElementById("countryIncompatibleText").innerHTML = "<strong>Petrol &amp; Diesel:</strong> All <strong>2013</strong> or newer car &amp; light truck (i.e. SUVs, pickups, minivans, etc.) makes &amp; models work with BlueDriver.<p><strong>Enhanced codes</strong> (ABS, SRS, etc) are available for most compatible vehicles from GM, Ford, Chrysler, Toyota, Mazda, Mitsubishi, Mercedes-Benz, Hyundai, and Nissan.</p><p><strong>Repair Reports</strong> are available for vehicles with North American VINs only.</p>";
            break;
        case 'JP':
            document.getElementById("countryIncompatibleText").innerHTML = "<strong>Petrol &amp; Diesel:</strong> All <strong>2010</strong> or newer car &amp; light truck (i.e. SUVs, pickups, minivans, etc.) makes &amp; models work with BlueDriver.<p><strong>Enhanced codes</strong> (ABS, SRS, etc) are available for most compatible vehicles from GM, Ford, Chrysler, Toyota, Mazda, Mitsubishi, Mercedes-Benz, Hyundai, and Nissan.</p><p><strong>Repair Reports</strong> are available for vehicles with North American VINs only.</p>";
            break;
        case 'TW':
            document.getElementById("countryIncompatibleText").innerHTML = "<strong>Petrol &amp; Diesel:</strong> All <strong>2008</strong> or newer car &amp; light truck (i.e. SUVs, pickups, minivans, etc.) makes &amp; models work with BlueDriver.<p><strong>Enhanced codes</strong> (ABS, SRS, etc) are available for most compatible vehicles from GM, Ford, Chrysler, Toyota, Mazda, Mitsubishi, Mercedes-Benz, Hyundai, and Nissan.</p><p><strong>Repair Reports</strong> are available for vehicles with North American VINs only.</p>";
            break;
        case 'AU':
            document.getElementById("countryIncompatibleText").innerHTML = "<strong>Petrol:</strong> All <strong>2006</strong> or newer car &amp; light truck (i.e. SUVs, pickups, minivans, etc.) makes &amp; models work with BlueDriver.<p><strong>Diesel:</strong> All <strong>2007</strong> or newer car &amp; light truck (i.e. SUVs, pickups, minivans, etc.) makes &amp; models work with BlueDriver.</p><p><strong>Enhanced codes</strong> (ABS, SRS, etc) are available for most compatible vehicles from GM, Ford, Chrysler, Toyota, Mazda, Mitsubishi, Mercedes-Benz, Hyundai, and Nissan.</p><p><strong>Repair Reports</strong> are available for vehicles with North American VINs only.</p>";
            break;
        case '':
            break;
        default:
            document.getElementById("countryIncompatibleText").innerHTML = "BlueDriver is compatible with all vehicles that support OBDII diagnostics. However, OBDII compliance varies depending on geographical region and year. For example, North America began requiring OBDII compliance in 1996, and Europe in 2001 (2004 for diesel).<br><br>"
            + "<strong>Unfortunately, " + countrySelect.options[countrySelect.selectedIndex].text.toUpperCase() + " does not require the use of OBDII diagnostics in locally sold vehicles. As a result, we cannot guarantee that any vehicle sold in this region will be compatible with BlueDriver.</strong><br><br>"
            + "<strong>If your vehicle has a sticker or plate in the engine bay that states 'OBDII Certified' or 'EOBD Compatible' your vehicle will support:</strong><br><br>";
    }
});

yearSelect.addEventListener("change", function(e)   { 

    hideContentRectangles();

    document.querySelectorAll('#make option').forEach(option => option.remove())
    makeSelect.add(new Option("Make", ""));

    document.querySelectorAll('#model option').forEach(option => option.remove())
    modelSelect.add(new Option("Model", ""));

    document.querySelectorAll('#engine option').forEach(option => option.remove())
    engineSelect.add(new Option("Engine", ""));

    hideLabel("engine");
    hideLabel("model");
    hideLabel("make");

    let makesList = [];

    for (let x in data)  
    {
        for (let y in data[x])
        {
            for (let z in data[x][y])
            {
                if (z === yearSelect.value)
                {
                    if (!makesList.includes(x))
                    {
                        makeSelect.add(new Option(x, x));                                        
                        makesList.push(x);
                    }
                }
            }
        }         
    }
    

    if (yearSelect.value == "")
    {
        hideLabel("year");
    }

    else
    {
        document.getElementById("year").style.fontSize = "14px";
        document.getElementById("year").style.paddingTop = "14px";
        document.getElementById("year").style.paddingBottom = "2px";
        document.getElementById("year label").style.display = "block";
    }
});

makeSelect.addEventListener("change", function(e) { 

    hideContentRectangles();

    document.querySelectorAll('#model option').forEach(option => option.remove())
    modelSelect.add(new Option("Model", ""));

    document.querySelectorAll('#engine option').forEach(option => option.remove())
    engineSelect.add(new Option("Engine", ""));

    hideLabel("engine");
    hideLabel("model");

    for (let y in data[makeSelect.value])
    {
        for (let z in data[makeSelect.value][y]) 
        {
            if ((data[makeSelect.value][y][yearSelect.value] == data[makeSelect.value][y][z]))
            {
                modelSelect.add(new Option(y, y));
            }
        }
    }

    if (makeSelect.value == "")
    {
        hideLabel("year");
    }

    else
    {
        document.getElementById("make").style.fontSize = "14px";
        document.getElementById("make").style.paddingTop = "14px";
        document.getElementById("make").style.paddingBottom = "2px";
        document.getElementById("make label").style.display = "block";        
    }
});

modelSelect.addEventListener("change", function(e) {

    hideContentRectangles();

    document.querySelectorAll('#engine option').forEach(option => option.remove())
    engineSelect.add(new Option("Engine", ""));

    hideLabel("engine");

    if (data[makeSelect.value][modelSelect.value] !== undefined)
    {
        for (let z in data[makeSelect.value][modelSelect.value][yearSelect.value]) 
        {
            engineSelect.add(new Option(z, z));
        }
    }
        
    if (modelSelect.value == "")
    {
        hideLabel("year");
    }

    else
    {
        document.getElementById("model").style.fontSize = "14px";
        document.getElementById("model").style.paddingTop = "14px";
        document.getElementById("model").style.paddingBottom = "2px";
        document.getElementById("model label").style.display = "block";        
    }
});

engineSelect.addEventListener("input", function(e) {

    let engineData = data[makeSelect.value][modelSelect.value][yearSelect.value][engineSelect.value];
    let serviceData = makeSelect.value;

    hideContentRectangles();

    document.getElementById("additional-systems-title").style.display = "none";

    document.getElementById("serviceFeatures").style.display = "none";

    document.getElementById("liveDataContent").innerHTML = "";
    document.getElementById("liveDataPids").innerHTML = "";
    document.getElementById("restrictionDisplayContent").innerHTML = "";
    

    if (engineSelect.options[engineSelect.selectedIndex].text == "Engine") 
    {
        hideContentRectangles();
    }

    else 
    {
        document.getElementById("mmye-display").innerHTML = 
         "<span class='divider'>"+ countrySelect.options[countrySelect.selectedIndex].text+ " </span> "
        +  "<span class='divider'>"+yearSelect.options[yearSelect.selectedIndex].text + " </span> "
        +  "<span class='divider'>"+makeSelect.options[makeSelect.selectedIndex].text + " </span> "
        +  "<span class='divider'>"+modelSelect.options[modelSelect.selectedIndex].text + " </span> "
        +  "<span class='divider'>"+engineSelect.options[engineSelect.selectedIndex].text +" </span> ";
       

        document.getElementById("selector-flex").style.display = "none";

        document.getElementById("mmye-display").style.display = "flex";
        document.getElementById("mmye-edit-button").style.display = "flex";

        if (engineData["Message"] !== null)
        {
            document.getElementById("messageDisplayContent").innerHTML = "<strong>COMPATIBILITY NOTE: </strong>" + engineData["Message"];
            document.getElementById("messageDisplayContent").classList.toggle("active", true);
        }
            
        else 
        {
            document.getElementById("messageDisplayContent").classList.toggle("active", false);  
            document.getElementById("messageDisplayContent").innerHTML = "";              
        }

        if (engineData["OBD"] === false)
        {
            document.getElementById("obdUnsupportedContent").classList.toggle("active",true);           
        }

        else 
        {
            document.getElementById("obdUnsupportedContent").classList.toggle("active",false);

            fetchServiceFeatures(serviceData);

            if ((engineData["PID"] === null) || (engineData["PID"] === "0"))
            {
                document.getElementById("liveDataContent").innerHTML = 
                "Your vehicle supports live data, but we do not currently have a list of what datapoints are available. " +
                "Your vehicle will provide this list to the scanner on connection. If you have any questions, please contact support any time.";
            }

            else 
            {
                fetchLiveData(engineData["PID"]);
            }

            if (engineData["Restrictions"] !== null)
            {
                if (engineData["Enhanced"] === true)
                {
                    let restrictionList = "<strong>";

                    document.getElementById('restrictionDisplayContent').style.border = "1px solid #b21515";
                    document.getElementById('restrictionDisplayContent').style.color = "#b21515";                    

                    for (let x in engineData["Restrictions"])
                    {

                        if ((engineData["Restrictions"][x] === ("Canada" || "CA")) && (countrySelect.value === "CA"))
                        {
                            document.getElementById('restrictionDisplayContent').style.border = "1px solid #202326";
                            document.getElementById('restrictionDisplayContent').style.color = "black";                            
                        }

                        if ((engineData["Restrictions"][x] === ("United States" || "US")) && (countrySelect.value === "US"))
                        {
                            document.getElementById('restrictionDisplayContent').style.border = "1px solid #202326";
                            document.getElementById('restrictionDisplayContent').style.color = "black";                            
                        }

                        if (x == 0)
                        {
                            restrictionList += engineData["Restrictions"][x];
                        }
                        
                        else
                        {
                            restrictionList += " & " + engineData["Restrictions"][x];
                        }

                    }              
                    
                    restrictionList += "</strong>";
                        
                    document.getElementById("restrictionDisplayContent").classList.toggle("active", true);

                    document.getElementById("restrictionDisplayContent").innerHTML =
                    "<strong>REGION NOTE: </strong>Enhanced diagnostic features are available in " + restrictionList +
                    ". Outside of these regions, all features will be available except enhanced systems (ABS, Airbags, etc.)"
                }
            }

            if ((engineData["Enhanced"] === false) || (engineData === undefined))
            {
                document.getElementById("unknownEnhancedContent").classList.toggle("active", false);
                document.getElementById("basicSupportedFeatures").style.display = "flex";
                document.getElementById("liveData").style.display = "flex";
                document.getElementById("enhancedDiagnostics").style.display = "none";
                document.getElementById("enhancedAdditionalFeatures").style.display = "none";
            }

            else
            {
                if (engineData["Systems"] === null)
                {
                    document.getElementById("unknownEnhancedContent").classList.toggle("active", true);
                    document.getElementById("enhancedDiagnostics").style.display = "none";
                    document.getElementById("enhancedAdditionalFeatures").style.display = "none";
                    document.getElementById("basicSupportedFeatures").style.display = "flex";
                }

                else if (engineData["Systems"] === undefined)
                {                    
                    document.getElementById("unknownEnhancedContent").classList.toggle("active", false);
                    document.getElementById("enhancedDiagnostics").style.display = "none";
                    document.getElementById("enhancedAdditionalFeatures").style.display = "flex";
                    document.getElementById("basicSupportedFeatures").style.display = "none";
                }

                else
                {
                    systemAvailabilityUpdate(engineData);
                    
                    document.getElementById("enhancedDiagnostics").style.display = "flex";
                    document.getElementById("enhancedAdditionalFeatures").style.display = "flex";
                    document.getElementById("basicSupportedFeatures").style.display = "none";
                }

                document.getElementById("liveData").style.display = "flex";
            }
        }
    }

    if (engineSelect.value == "")
    {
        hideLabel("year");     
    }

    else
    {
        document.getElementById("engine").style.fontSize = "14px";
        document.getElementById("engine").style.paddingTop = "14px";
        document.getElementById("engine").style.paddingBottom = "2px";
        document.getElementById("engine label").style.display = "block";        
    }
});

document.getElementById("countryRequirementText").addEventListener("click", function(e) { 

    document.getElementById("country-requirement-display").classList.toggle("shrunk", true);
});

document.getElementById("country-requirement-display-close").addEventListener("click", function(e) { 

    document.getElementById("country-requirement-display").classList.toggle("shrunk", false);
});

window.addEventListener("load", function(e) {
});

document.getElementById("mmye-edit-button").addEventListener("click", function(e) {
    document.getElementById("selector-flex").style.display = "flex";
    document.getElementById("mmye-display").style.display = "none";
    document.getElementById("mmye-edit-button").style.display = "none";
});

function getText (system) {
    let additionalSystemText;

        switch (system) { 
            case 'Battery and Power': 
                additionalSystemText = "Power distribution and battery health monitoring systems.";
                break;
            case 'Doors and Windows':
                additionalSystemText = "Door controls and locks, power windows, power sliding/rear doors, convertible tops, etc.";
                break;
            case 'Driver Assist and Active Safety':
                additionalSystemText = "Active cruise control, lane assist, emergency braking, pedestrian detection, etc.";
                break;        
            case 'Driver Information and Control':
                additionalSystemText = "Instrument panel, displays/screens, buttons and control panels, etc.";
                break;        
            case 'Entertainment and Navigation':
                additionalSystemText = "Stereo, navigation systems, amplifiers, CD changers, etc.";
                break;        
            case 'Heat and Air Conditioning':
                additionalSystemText = "Heat, air conditioning, climate control.";
                break;        
            case 'Lights':
                additionalSystemText = "Headlights, interior lighting.";
                break;        
            case 'Premium Vehicle Options':
                additionalSystemText = "Wifi hotspots, sun shades, active noise cancellation, automatic running boards, etc.";
                break;        
            case 'Seats and Mirrors':
                additionalSystemText = "Heated and power seats, heated mirrors, mirror controls, etc.";
                break;        
            case 'Security & Keyless Entry':
                additionalSystemText = "Keyless entry, immobilizers, remote starters, etc.";
                break;        
            case 'Trailer and Auxiliary Equipment':
                additionalSystemText = "Trailer brakes, power take-offs, etc.";
                break;
            case 'Vehicle Control and Suspension':
                additionalSystemText = "Power steering, active/electronic suspension or dampeners, etc.";
                break;                        
            default: 
    };

    return additionalSystemText;
}

function systemAvailabilityUpdate(data) {

    document.getElementById("serviceFeatures").style.display = "none";
    document.getElementById("active-service-features").style.display = "none";

    document.getElementById("additional-systems-flex").innerHTML = "";

    document.getElementById("additional-systems-title").style.display = "none";

    for (let x in data["Systems"]["Primary"])
    {
        if (data["Systems"]["Primary"][x] === true)
        {
            document.getElementById(x + " box").style.display = "flex";

            if (x === "Engine")
            {
                document.getElementById(x).innerHTML = "<div class=\"primary-systems-check check-mark check-mark\"></div>";

                document.getElementById(x + " subtext").style.display = "block";    

                document.getElementById(x + " subtext").innerHTML = "Systems related to the operation of the engine - " + 
                "engine/powertrain controller, electronic fuel pump, starter, etc.";

                document.getElementById(x + " subtext alt").style.display = "none";
            }
            
            else 
            {
                document.getElementById(x).innerHTML = "<div class=\"primary-systems-check check-mark check-mark\"></div>";

                document.getElementById(x + " box").classList.toggle("unavailable", false); 

                document.getElementById(x + " title").classList.toggle("unavailable", false); 

                document.getElementById(x + " subtext").style.display = "block";

                document.getElementById(x + " subtext alt").style.display = "none";
            }
        }

        else if (data["Systems"]["Primary"][x] === false)
        {
            document.getElementById(x + " box").style.display = "flex";

            if (x === "Engine")
            {
                document.getElementById(x).innerHTML = "<div class=\"primary-systems-check check-mark check-mark\"></div>";

                document.getElementById(x + " subtext").style.display = "block";    

                document.getElementById(x + " subtext").innerHTML = "<strong>Note:</strong> This vehicle " +
                "only supports Check Engine Light codes from the engine module.";

                document.getElementById(x + " subtext alt").style.display = "none";
            }

            else 
            { 
                document.getElementById(x).innerHTML = "<div class=\"primary-systems-cross cross-mark\"></div>";

                document.getElementById(x + " box").classList.toggle("unavailable", true); 

                document.getElementById(x + " title").classList.toggle("unavailable", true); 

                document.getElementById(x + " subtext alt").innerHTML = "Not supported by this vehicle.";

                document.getElementById(x + " subtext").style.display = "none";

                document.getElementById(x + " subtext alt").style.display = "block";
            }
        }

        else if (data["Systems"]["Primary"][x] === null)
        {
            document.getElementById(x + " box").style.display = "none";

            document.getElementById(x + " title").classList.toggle("unavailable", true); 

            document.getElementById(x).innerHTML = "<div class=\"system-not-available\">N/A</div>";

            document.getElementById(x + " subtext alt").innerHTML = "Your vehicle does not have this system.";

            document.getElementById(x + " subtext").style.display = "none";

            document.getElementById(x + " subtext alt").style.display = "block";            
        }

        if (data["Systems"]["Primary"]["Hybrid and EV"] === true)
        {
            document.getElementById("Hybrid and EV box").style.display = "flex";
        }

        else 
        {       
            document.getElementById("Hybrid and EV box").style.display = "none";
        }
    }

    let systemCount = 0;

    for (let y in data["Systems"]["Secondary"])
    {
        if (data["Systems"]["Secondary"][y] == true) 
        {
            document.getElementById("additional-systems-title").style.display = "flex";

            if (systemCount == 0) 
            {
                divider = "";
            }

            else if (systemCount == 1)
            {
                divider = "<div class=\"system-divider-alt\"></div>";
            }
            
            else
            {
                divider = "<div class=\"system-divider\"></div>";
            }


            document.getElementById("additional-systems-flex").innerHTML += 

                "<div class=\"additional-systems-box\">" + divider +

                        "<div class=\"additional-systems-field\">" +
                            
                            "<div class=\"additional-systems-text\">" +

                                "<div class=\"additional-systems-check check-mark check-mark\"></div>" + y + "</div>" +

                            "<div class=\"additional-systems-tooltip\">" +
                                "<div class=\"text-tooltip-icon\"></div>" +
                                "<div class=\"text-tooltip-container\">" +
                                    "<div class=\"text-tooltip\">" +

                                    getText (y) +

                                    "</div>" +
                                "</div>" +
                            "</div>" +
            
                        "</div>" +

                "</div>";

            systemCount++;
        }    
    }
}

function hideContentRectangles () {

    document.getElementById("basicSupportedFeatures").style.display = "none";
    document.getElementById("liveData").style.display = "none";
    document.getElementById("enhancedDiagnostics").style.display = "none";
    document.getElementById("enhancedAdditionalFeatures").style.display = "none";   
    document.getElementById("serviceFeatures").style.display = "none";


    document.getElementById("restrictionDisplayContent").classList.toggle("active", false);
    document.getElementById("unknownEnhancedContent").classList.toggle("active", false);
    document.getElementById("obdUnsupportedContent").classList.toggle("active", false);
    document.getElementById("messageDisplayContent").classList.toggle("active", false);
}

function hideLabel (labelTitle) {

    document.getElementById(labelTitle).style.fontSize = "16px";
    document.getElementById(labelTitle).style.paddingTop = "8px";
    document.getElementById(labelTitle).style.paddingBottom = "8px";
    document.getElementById(labelTitle + " label").style.display = "none";
}


function fetchLiveData (PID) {

    jQuery.ajax ({
        type: 'GET',
        url: 'https://obd2blue.bluedriver.com/cgi-bin/pids.pl?pids=' + PID + '&format=full',

        dataType: 'jsonp',
        success: function(data) 
        {
            document.getElementById("liveDataContent").innerHTML =
                "For a detailed explanation of various live data sources, please visit our <a href=\"https://www.bluedriver.com/livedata\" target=\"_blank\">Live Data Guide</a>.<br>";

            let pidLength = (data["pids"].length)/2;

            let categoryList = [];

            for (let x in data["pids"])
            {
                for (let y in data["pids"][x]["categories"])
                {
                    if (!categoryList.includes(data["pids"][x]["categories"][y]))
                    {
                        let stringTemp = "";

                        let catName = data["pids"][x]["categories"][y];
                        
                        stringTemp +=  "<div class=\"pid-content-flex\">" + "<div class=\"pid-content-box\"><div class=\"pid-content-title\"><div class=\"pid-content-expander\">+</div>" + data["pids"][x]["categories"][y] +
                                    "</div><div class=\"pid-content-tooltip\"><div class=\"text-tooltip-icon\"></div><div class=\"text-tooltip-container\"><div class=\"text-tooltip\">" + data["categories"][catName] + ".</div></div></div></div><div class=\"pid-system-divider\"></div>" +
                                    "<div class=\"pid-content-description full-format\">"; 
                                    

                        for (let z in data["pids"])
                        {  
                            for (let w in data["pids"][z]["categories"])
                            {
                                if (data["pids"][x]["categories"][y] == data["pids"][z]["categories"][w])
                                {
                                    stringTemp += "• " + data["pids"][z]["description"] + "<br>";
                                }
                            }
                        }
                        

                        stringTemp += "</div></div>";

                        document.getElementById("liveDataPids").innerHTML += stringTemp;

                        categoryList.push(data["pids"][x]["categories"][y]);

                    }
                }
            }    

            addPIDExpanders();

        }

    });

}

function fetchServiceFeatures(make) {

    document.getElementById("serviceFeatures").style.display = "none";
    document.getElementById("active-service-features").style.display = "none";
    document.getElementById("passive-service-features").style.display = "none";
    document.getElementById("oil-light-reset").style.display = "none";
    document.getElementById("tpms-light-reset").style.display = "none";

    jQuery.ajax ({
        type: 'GET',
        url: 'https://obd2blue.bluedriver.com/cgi-bin/reset-instructions.pl?parent=' + make,

        dataType: 'jsonp',
        success: function(res) 
        {
            if ((res["oil"] === undefined) && (res["tpms"] === undefined) && (data[makeSelect.value][modelSelect.value][yearSelect.value][engineSelect.value]["Other"]["Battery"] === undefined))
            {
            }

            else 
            {
                if (res["oil"] !== undefined)
                {
                    document.getElementById("oil-light-reset").style.display = "flex";
                    document.getElementById("passive-service-features").style.display = "block";
                }

                if (res["tpms"] !== undefined)
                {
                    document.getElementById("tpms-light-reset").style.display = "flex";
                    document.getElementById("passive-service-features").style.display = "block";
                }

                if (data[makeSelect.value][modelSelect.value][yearSelect.value][engineSelect.value]["Other"]["Battery"] !== undefined)
                {
                     document.getElementById("active-service-features").style.display = "block";
                }

            document.getElementById("serviceFeatures").style.display = "flex";
            }
        }
    });
}


function addPIDExpanders() {

    expanders = document.getElementsByClassName("pid-content-box");

    for (let i=0; i<expanders.length; i++)
    {

        if ((expanders[i].parentElement.children[2].innerHTML.split("<br>").length - 1) > 1)
        {
            expanders[i].addEventListener("click", function(e) {

                if (e.target.classList[0] == "text-tooltip-icon") {
                }

                else {
                    expanders[i].parentElement.children[2].classList.toggle("shown");

                    if (expanders[i].children[0].children[0].innerHTML == "+")
                    {
                        expanders[i].children[0].children[0].innerHTML = "-";
                    }

                    else if (expanders[i].children[0].children[0].innerHTML == "-")
                    {
                        expanders[i].children[0].children[0].innerHTML = "+";
                    }
                }
            });
        }

        else
        {
            expanders[i].children[0].children[0].innerHTML = "";
        }
    }
}



  } catch(e) { console.error(e); }
})();
})();
